$("body").on(
  "change",
  '#bc-sf-filter-wrapper .list-radios input[type="radio"], .section-recommended .list-radios input[type="radio"]',
  function() {
    const $btn = $(this)
      .closest("form")
      .find(".form__btn");
    $btn.prop("disabled", false).removeClass("disabled");
  }
);
